import Vue from 'vue'

Vue.filter('priceFormat', (value) => {
  if (!value && value !== 0) return ''
  if (typeof value === 'number') {
    const reg = /\d{1,3}(?=(\d{3})+$)/g
    return (`${value}`).replace(reg, '$&,')
  }
})
